// Open a patient on another page: their profile on Patients, or Eligibility with them
// already selected (the Appointments page's patient name and "Check Eligibility").
//
// The same two-part hand-off as features/reports/ledgerLink.js: the patient travels in
// a module-scoped variable keyed by practice AND page, which the target reads once on
// mount; the navigation pushes `/p/<practice>/<page>` and announces it with `popstate`,
// which App.js already honours. Back returns to where the click came from. Only the id
// travels, never a name or a DOB — except as `prefill`, the one visit's coverage that
// "Check Eligibility" hands the check form (payer, member id, DOB, provider, date),
// which the target reads once and drops with the link.

let pending = null; // { practiceId, page, patientId, prefill }

export function openPatientOn(page, practiceId, patientId, prefill = null) {
  if (!practiceId || !patientId) return;
  pending = { practiceId: Number(practiceId), page, patientId: Number(patientId), prefill: prefill || null };
  try {
    window.history.pushState({}, "", `/p/${practiceId}/${page}`);
    window.dispatchEvent(new PopStateEvent("popstate"));
  } catch (_) {
    /* a browser without the History API: the patient waits for the next visit */
  }
}

function pendingFor(page, practiceId) {
  if (!pending || pending.page !== page || pending.practiceId !== Number(practiceId)) {
    return null;
  }
  return pending;
}

/** The patient id handed to this page for this practice, or null. Read on mount;
    `clearPatientLink` runs once the page has acted on it. */
export function peekPatientLink(page, practiceId) {
  const p = pendingFor(page, practiceId);
  return p ? p.patientId : null;
}

/** The prefill handed along with the patient (see openPatientOn), or null. */
export function peekPatientPrefill(page, practiceId) {
  const p = pendingFor(page, practiceId);
  return p ? p.prefill : null;
}

export function clearPatientLink() {
  pending = null;
}
